<template>
    <section id="Verse" class="Prayer white-text">
        <div class="row container">
            <div class="col s12 m12 l10 offset-l1 center">
                <p>{{ verse }}<span>{{ reference }}</span></p>
                <VerseOfTheDay v-if="false" v-bind:votd="votd"/> 
            </div>
        </div>
    </section>
</template>

<script>
    import VerseOfTheDay from '../../components/VOTD.vue'
    // import VerseService from '../../services/Verses.js';
    
    export default {
        name: 'Verse',
        components: { VerseOfTheDay },
        data: function () {
            return {
                verse: "No eye has seen, no ear has heard, and no mind has imagined what God has prepared for those who love him.",
                reference: "1 Corinthians 2:9",
                votd: {
                    Image: "",
                    Verse: ""
                }
            }
        },
        created: function() {
            // var self = this;
            // var today = new Date();
            // var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

            // var saveVOTD = {
            //     date: date,
            //     verse: "",
            //     reference: "",
            //     votd: {
            //         Image: "",
            //         Verse: ""
            //     }
            // }

            // var getVOTD = true;
            // if (sessionStorage.getItem("VOTD")) {
            //     var localVOTD = JSON.parse(sessionStorage.getItem("VOTD"));
            //     if (date == localVOTD.date) {
            //         getVOTD = false;
            //         self.reference = localVOTD.reference;
            //         self.verse = localVOTD.verse;
            //         self.votd.Image = localVOTD.votd.Image;
            //         self.votd.Verse = localVOTD.votd.Verse;
            //     }
            // }

            // if (getVOTD) {
            //     VerseService.getVOTD().then(function(response) {            
            //         self.votd.Image = "http:" + response.image.url.replace("{width}", "500").replace("{height}", "500");
            //         saveVOTD.votd.Image = self.votd.Image;

            //         self.reference = response.verse.human_reference
            //         saveVOTD.reference = self.reference;

            //         const reference = self.reference;
            //         var referenceArray = reference.split(" ");
            //         let book, chapter, verse;
            //         if ((referenceArray.length - 1) == 1) {
            //             book = referenceArray[0];
            //             chapter = referenceArray[1].split(":")[0];
            //             verse = referenceArray[1].split(":")[1];
            //         }
            //         else {
            //             book = referenceArray[0] + referenceArray[1];
            //             chapter = referenceArray[2].split(":")[0];
            //             verse = referenceArray[2].split(":")[1];
            //         }

            //         book = book.toLowerCase();

            //         VerseService.getVerse(book, chapter, verse, "niv").then(function(response){
            //             self.verse = response;
            //             saveVOTD.verse = self.verse;

            //             self.votd.Verse = response + " " + reference;
            //             saveVOTD.votd.Verse = self.votd.Verse;

            //             sessionStorage.setItem('VOTD', JSON.stringify(saveVOTD));
            //         });
            //     })
            // }

            // var saveVOTD = {
            //     date: date,
            //     verse: "",
            //     reference: "1 Corinthians 2:9",
            //     votd: {
            //         Image: "",
            //         Verse: ""
            //     }
            // }

            // let book = "1corinthians";
            // let chapter = "2";
            // let verse = "9";
            // let reference = "1 Corinthians 2:9"

            // VerseService.getVerse(book, chapter, verse, "niv").then(function(response){
            //     self.verse = response;
            //     saveVOTD.verse = self.verse;

            //     self.votd.Verse = response + " " + reference;
            //     saveVOTD.votd.Verse = self.votd.Verse;

            //     sessionStorage.setItem('VOTD', JSON.stringify(saveVOTD));
            // });
        }
    }
</script>

<style scoped>
    /* @import '//cdn.jsdelivr.net/npm/@sweetalert2/theme-material-ui/material-ui.css'; */

    section {
        padding: 8.5rem 0 6.5rem 0;
        background: rgba(9,12,13, 1);
        background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(9,12,13, 1)), to(rgba(63, 66, 67, 1)));
        background-image: linear-gradient(rgba(9,12,13, 1), rgba(63, 66, 67, 1));
        background-size: cover;
        min-height: 300px;
    }
    p {
        font-size: 3rem;
        line-height: 1.25;
        font-family: NewhouseDTCond-ExtBold;
    }

    p span {
        display: block;
        padding-top: 10px;
        font-size: 2rem;
        color: rgba(91,124,138, 1);
    }
</style>